import { render, staticRenderFns } from "./UILegalDisclaimer.vue?vue&type=template&id=e386e4b8&scoped=true"
import script from "./UILegalDisclaimer.vue?vue&type=script&lang=js"
export * from "./UILegalDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./UILegalDisclaimer.vue?vue&type=style&index=0&id=e386e4b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e386e4b8",
  null
  
)

export default component.exports